<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-auto">
        <h3 class="font-weight-bolder mt-3">Health Checklist</h3>
      </div>
      <div class="col-sm-auto my-auto">
        <template v-if="crew.active == 1">
        <CrewHealthChecklistPasscode
            v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
        </CrewHealthChecklistPasscode>
        </template>
      </div>

      <template v-if="crew.active == 1">
      <UploadHealthChecklist v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
      </UploadHealthChecklist>
      </template>

      <div class="col col-sm-12">
        <MedicalNavigation></MedicalNavigation>
      </div>

      <div class="col-sm-12">
        <table class="table table-sm table-hover table-bordered text-small text-center"
               style="border-color: lightgray;">
          <thead class="bg-lightgray">
          <tr>
            <th class="col-index">#</th>
            <th>Passcode</th>
            <th>Date Generated</th>
            <th>Date Accessed</th>
            <th>Date Submitted</th>
            <th>Days to Expire</th>
            <th>Symptoms</th>
            <th v-if="isSystemAdmin">Generated By</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crewMedicalDeclaration, index) in crewMedicalDeclarations" :key="crewMedicalDeclaration.id"
                :class="{'bg-lightsilver': crewMedicalDeclaration.daysToExpire === 'EXPIRED'}"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ crewMedicalDeclaration.passcode }}</td>
              <td>{{ crewMedicalDeclaration.createdAt }}</td>
              <td>{{ crewMedicalDeclaration.loggedAt }}</td>
              <td>{{ crewMedicalDeclaration.submittedAt }}</td>
              <td
                  class="font-weight-bolder"
                  :class="{
                          'text-secondary': crewMedicalDeclaration.daysToExpire === 'N/A',
                          'text-success': crewMedicalDeclaration.daysToExpire !== 'N/A',
                          'text-black-50': crewMedicalDeclaration.daysToExpire === 'EXPIRED',
                      }"
              >{{ crewMedicalDeclaration.daysToExpire }}
              </td>
              <td
                  :class="{'text-danger font-weight-bolder' : crewMedicalDeclaration.has_symptoms}"
              >{{ crewMedicalDeclaration.has_symptoms ? 'Yes' : 'None' }}
              </td>
              <td v-if="isSystemAdmin">{{ crewMedicalDeclaration.scheduledBy }}</td>
              <td>
                <button class="btn btn-sm btn-xs btn-outline-info"
                        v-if="crewMedicalDeclaration.hasFile"
                        @click="updateMedicalDeclarationFile(crewMedicalDeclaration.id)">
                  <span class="fas fa-file-alt"></span>
                  View
                </button>
                <template v-if="crew.active == 1 || isSystemAdmin">
                  <button class="btn btn-sm btn-xs btn-outline-danger"
                          v-if="isSystemAdmin && !isKline"
                          @click="confirmDeleteCrewMedicalDeclaration(crewMedicalDeclaration.id)">
                    <span class="fas fa-trash"></span>
                    Delete
                  </button>
                </template>
              </td>

            </tr>
          </template>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>


import MedicalNavigation
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/MedicalNavigation";
import CrewHealthChecklistPasscode from "@/components/elements/CrewHealthChecklistPasscode";
import UploadHealthChecklist from "@/components/elements/UploadHealthChecklist";

import {gateMixin} from "@/mixins/gateMixin";
import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from "@/mixins/vueAppMixin";
import AppLoading from "@/components/elements/AppLoading";

export default {

  name: "HealthChecklist",

  mixins: [vueAppMixin, gateMixin, AppLoading],

  data() {
    return {
      medicalDeclarationFile: '',
    }
  },

  components: {MedicalNavigation, CrewHealthChecklistPasscode, UploadHealthChecklist, AppLoading},

  methods: {
    ...mapActions([
      'getCrewMedicalDeclarationFile',
      'deleteCrewMedicalDeclaration',
      'setLoading',
      'getCrewMedicalDeclarations'
    ]),

    async initializeData() {
      let params = {
        crewId: this.crew.id
      }
      this.setLoading(true);
      await this.getCrewMedicalDeclarations(params);
      this.setLoading(false);
    },

    async updateMedicalDeclarationFile(crewMedicalDeclarationId) {
      let params = {
        crewMedicalDeclarationId: crewMedicalDeclarationId
      };
      let medicalDeclarationFile = await this.getCrewMedicalDeclarationFile(params);
      this.medicalDeclarationFile = medicalDeclarationFile ? `data:application/pdf;base64,${medicalDeclarationFile}` : '';
      await this.pdfViewer('Medical Declaration File', this.medicalDeclarationFile);
    },

    async confirmDeleteCrewMedicalDeclaration(crewMedicalDeclarationId) {
      if (await this.confirmDeleteAlert()) {
        let params = {
          id: crewMedicalDeclarationId
        };
        let deletedCrewMedicalDeclaration = await this.deleteCrewMedicalDeclaration(params);
        if (deletedCrewMedicalDeclaration) {
          this.successAlert('Medical Declaration Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Medical Declaration Failed to Delete', 'DELETE');
        }
      }
    }
  },

  computed: {
    ...mapGetters(['crew', 'crewMedicalDeclarations'])
  },

  created() {
    this.initializeData();
  }
}
</script>

<style scoped>
* {
  font-family: 'Nunito', sans-serif;
}

.bg-lightgray {
  background: lightgray;
}
</style>